const loyaltyConstants = {
	vipTiers: {
		currentStatusLabel: "current status",
      benefitHeaders: [
            "EARN POINTS FOR EVERY DOLLAR SPENT",
			"EARLY ACCESS",
			"BIRTHDAY GIFT",
            "EXCLUSIVE PRODUCTS + GIFTS WITH PURCHASE",
            "extra points for reviews",
            "ACCESS TO extra POINTS EVENTS",
            "FREE GIFT WITH STATUS INCREASE",
         "DEDICATED STYLING APPOINTMENTS",
            "ACCESS TO EXCLUSIVE events",
            "VIP CONCIERGE SERVICES"
           
		],
		benefitsList: [
			{
				tierId: 16713,
				tierRequirement: "0 - 499 Points",
				benefits: [
                  "1X",
					"⬤",
                  "$10",
                  "⬤",
                  "",
                  "⬤",
                  "",
                   "⬤",
                  "",
        		  	""
                 
				]
			},
			{
				tierId: 16714,
				tierRequirement: "500 - 2000 Points",
				benefits: [
                  "1.5X",
				  "⬤⬤",
                  "$25",
                  "⬤",
                  "⬤⬤",
                  "⬤⬤",
                  "",
                   "⬤⬤",
                  "⬤",
        		  	""
				]
			},			
			{
				tierId: 16715,
				tierRequirement: "2000+ Points",
				benefits: [
                  "2X",
				  "⬤⬤⬤",
                  "$50",
                  "⬤",
                  "⬤⬤⬤",
                  "⬤⬤⬤",
                  "⬤⬤⬤",
                   "⬤⬤⬤",
                  "⬤",
        		  	"⬤"
      
				]
			}

		]

	}
	
}